import { render } from "./SubTitleCard.vue?vue&type=template&id=50ca5657&scoped=true"
import script from "./SubTitleCard.vue?vue&type=script&lang=js"
export * from "./SubTitleCard.vue?vue&type=script&lang=js"

import "./SubTitleCard.vue?vue&type=style&index=0&id=50ca5657&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ca5657"]])

export default __exports__